var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-page-container"},[_c('div',{staticClass:"web-page-mid"},[_c('div',{staticClass:"web-page-inner"},[_c('WemeidaConfig',{ref:"WemeidaConfig",attrs:{"id":_vm.id,"type":_vm.type}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }